import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { fetchTestCasePerAuthor } from '../../../../../modules/dashboard';
import NoDataAvailable from './NoDataAvailable';
import {
  createQueryString,
  generateUniqueColors,
  getRandomColor,
} from '../../../../../lib/utils';
import ChartTitle from '../../../../elements/ChartTitle';
import { useQuery } from '@tanstack/react-query';

const GRAPH_TITLE = 'Test Cases By Author';

const TestCasesPerAuthor = ({ projectId, dateFilters }) => {
  const [colors, setColors] = useState([]);
  const queryString = createQueryString(dateFilters);

  const { data = [] } = useQuery({
    queryKey: ['testCasesPerAuthor', projectId, queryString],
    queryFn: async () => {
      const response = await fetchTestCasePerAuthor(projectId, queryString);
      return response?.data || [];
    },
    enabled: !!projectId && !!queryString,
    refetchOnWindowFocus: false,
  });

  const totalCount = data.reduce((sum, item) => sum + item.count, 0);
  useEffect(() => {
    if (data && data.length > 0) {
      const newColors = generateUniqueColors(data, getRandomColor);
      setColors(newColors);
    }
  }, [data]);

  return (
    <div className="chart-div">
      <ChartTitle title={GRAPH_TITLE} dateFilters={dateFilters} />
      {data.length === 0 ? (
        <NoDataAvailable type="other" />
      ) : (
        <>
          <p className="text-muted mb-0">Total Test Cases: {totalCount}</p>
          <ResponsiveContainer width="100%" height={320}>
            <PieChart>
              <Pie
                data={data}
                dataKey="count"
                nameKey="author_name"
                cx="50%"
                cy="50%"
                outerRadius={120}
                innerRadius={50}
                fontSize={12}
                label={({ name, value }) => `${name} (${value})`}>
                {data.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={colors[index]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
  );
};

export default TestCasesPerAuthor;
